import React, { useCallback } from 'react';
import { SegmentedButton } from '@ontruck/orc';
export const options = {
  ftl: { value: 'FTL', label: 'FTL' },
  ltl: { value: 'LTL', label: 'LTL' },
};

const BusinessFilter = ({ value, onChange, className }) => {
  const handleChange = useCallback(
    (_, { value: selectedValue }) => {
      onChange(selectedValue);
    },
    [onChange]
  );

  const handleFTLClick = useCallback(() => {
    if (value === options.ftl.value) {
      onChange(undefined);
    }
  }, [value, onChange]);

  const handleLTLClick = useCallback(() => {
    if (value === options.ltl.value) {
      onChange(undefined);
    }
  }, [value, onChange]);

  return (
    <div className={className} data-testid="business_filter">
      <SegmentedButton.Parent value={value} onChange={handleChange}>
        <SegmentedButton.Child
          value={options.ftl.value}
          label={options.ftl.label}
          onClick={handleFTLClick}
        />
        <SegmentedButton.Child
          value={options.ltl.value}
          label={options.ltl.label}
          onClick={handleLTLClick}
        />
      </SegmentedButton.Parent>
    </div>
  );
};

export default BusinessFilter;
